<section class="before-selfie">
  <img src="assets/images/verify_selfie.svg" width="185" alt="selfie" />

  <div class="before-selfie__title">
    Precisamos de uma fotografia sua para nosso processo de segurança.
  </div>

  <p>
    Você será
    <strong>redirecionado para o nosso parceiro, a Clearsale</strong> que irá
    garantir muito mais segurança do processo, siga o passo a passo e finalize o
    processo de privacidade e segurança.
  </p>

  <p>
    Nós avisaremos via SMS o resultado dessa etapa. Caso tenha algum problema ou
    ficou com alguma dúvida entre em contato com a Omni<br />
    Contatos: 0800 727 0885
  </p>
</section>
